export default {
    getProjectTasks: (projectId) => `/Tasks/GetProjectTasksTable?ProjectId=${projectId}`,
    getWorkspaceTasks: (workspaceId) => `/Tasks/GetWorkspaceTasksTable?WorkspaceId=${workspaceId}`
};
